<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { ProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
  import { onDestroy } from "svelte";

  export let selectedFilters: any;

  const mobileMode: boolean = $LayoutStore.isMobile;

  let applyFilters: any;
  let clearFilter: any;
  let clearAllFilters: any;
  const unsubscribe = ProductLineListingStore.subscribe(n => {
    applyFilters = n.onApplyFilters;
    clearFilter = n.onClearFilter;
    clearAllFilters = n.onClearAllFilters;
  });

  onDestroy(() => {
    unsubscribe();
  });

  const onClickFilterChip = filter => {
    if (clearFilter) {
      clearFilter(filter);
    }

    if (applyFilters) {
      applyFilters();
    }
  };

  const onClickClearAll = () => {
    if (clearAllFilters) {
      clearAllFilters();
    }

    if (applyFilters) {
      applyFilters();
    }
  };
</script>

{#if selectedFilters.length > 0}
  <div
    class:fizz-inset-vertical-16={!mobileMode}
    class="fizz-flex-row-4 fizz-flex-wrap"
    style="--gap: 4px;"
  >
    {#each selectedFilters as filter}
      <button
        class="fizz-flex-row-4 side-filter-token fizz-chip cursor-pointer"
        data-testid={"remove-filter-" + filter.id}
        on:click={() => onClickFilterChip(filter)}
      >
        <span class="fizz-text-brand">{filter.name}</span>
        <Icon type="Close" width={11} height={11} fill={"#052C48"} />
      </button>
    {/each}
    {#if mobileMode && selectedFilters.length > 1}
      <span
        class="fizz-text-medium fizz-text-interactive fizz-text-strong"
        on:click={onClickClearAll}
        data-testid="clear-all-filters"
      >
        Clear all
      </span>
    {/if}
  </div>
{/if}
